<template>
  <div class="contentH5">
    <div class="p1">
      <div class="p1-center">
        <div class="p1-title">
          <div class="title-tab">
            <div>
              <span @click="goAnchor('p1')">HOME</span>
              <span @click="goAnchor('p2')">ABOUT</span>
              <span @click="goAnchor('p3')">GALLERY</span>
              <span @click="goAnchor('p4')">CONTACT</span>
            </div>
            <img src="@/img/H5/Menu-Button.png" alt />
          </div>
        </div>
        <div class="p1-content">
          <div></div>
        </div>
        <div class="p1-down" @click="goAnchor('p2')">
          <div></div>
        </div>
      </div>
    </div>
    <div class="p1-flex"></div>
    <div class="p2">
      <div>
        <div class="p2-title">
          <p>{{ twoData.titleData.title }}</p>
          <div>
            <span
              v-for="(item, index) in twoData.titleData.textList"
              :key="index + 'title'"
              >{{ item }}</span
            >
          </div>
        </div>

        <div class="p2-center">
          <div v-for="(item, index) in twoData.spanList" :key="index + 'span'">
            <img :src="item.src" alt />
            <p>{{ item.title }}</p>
            <div>
              <span
                v-for="(item1, index1) in item.textList"
                :key="index + '-' + index1"
                >{{ item1 }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p3">
      <div class="p3-title">
        <div>
          <span>OUR PORTFOLIO</span>
          <p>我们的作品</p>
          <div>
            <p>
              上海文广演艺（集团）、上海话剧艺术中心、上海京剧院、上汽·上海文化广场、上海广播电视台
              、1862时尚艺术中心、台湾百庭文化、上海开心麻花文化传媒、欧西爱司物流（上海）、上海滑稽剧团、北京大道文化、上海锦辉艺术传播、国际舞蹈中心、上海市剧本创作中心、浙江话剧团、上海开心麻花文化传媒、欧西爱司物流（上海）、上海滑稽剧团、北京大道文化、上海锦辉艺术传播、国际舞蹈中心、上海市剧本创作中心、浙江话剧团
            </p>
          </div>
        </div>
        <div>
          <span ref="ALL" @click="changeClass('ALL')">ALL</span>
          <span ref="BRANDING" @click="changeClass('BRANDING')">BRANDING</span>
          <span ref="WEB" @click="changeClass('WEB')">WEB DESIGN</span>
        </div>
      </div>
      <div class="p3-content" ref="img-list">
        <Swiper ref="mySwiper1" :options="swiperOptions">
          <SwiperSlide v-for="(item, index) in imgData" :key="index + 'image1'">
            <img @click="clickPageAndShowPagse(item, index)" :src="item" alt />
          </SwiperSlide>

          <!--            <p class="swiper-button-next"></p>-->
          <!--            <p class="swiper-button-prev"></p>-->
          <!--            <div class="swiper-pagination" slot="pagination"></div>-->
        </Swiper>
      </div>
    </div>
    <div class="p4">
      <div class="p4-title">
        <div>
          <span>OUR Address</span>
          <p>
            <span>秀艺轩</span>
            <span class="black-text">在这里</span> <img src="@/img/web/path.png" alt /></p>
          <div>
            <p>上海市静安区彭江路602号大宁德比易园i座社群中心3楼303室</p>
            <p>
              Room 303, floor 3, building I, No. 602, Pengjiang Road, Jing'an
              District, Shanghai
            </p>
          </div>
        </div>
      </div>
      <div class="p4-content">
        <baidu-map
          class="map"
          :center="center"
          :zoom="zoom"
          :dragging="true"
          :scroll-wheel-zoom="false"
          @ready="handler"
        >
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-marker
            :position="{ lng: center.lng, lat: center.lat }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
        </baidu-map>
      </div>
      <div class="p4-footer">
        <span>SHOWART</span> © <span>{{ new Date().getFullYear() }}</span> All
        Right Reserved. <a target="_blank" href="http://beian.miit.gov.cn/">沪ICP备20010017号-1</a>
      </div>
    </div>
    <div class="fled" @click="goAnchor('p1')"></div>
    <Dialog
      :src="image"
      :is-h5="true"
      :isOpen="openDialog"
      @closePage="closePage"
    ></Dialog>
  </div>
</template>

<script>
import {
  title1,
  title2,
  title3,
  move01,
  move02,
  move03,
  move04,
  move05,
  move06,
  move07,
  move08,
  move09,
  move10,
  move11,
  move12,
  move13,
  move14,
  move15,
  move16,
  move17,
  move18,
  move19,
  move20,
  move21,
  move22,
  move23,
  move24,
  move25,
  move26,
  move27,
  move28
} from "@/utils/utils";
import Dialog from "./dialog";
import { directive, Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Dialog,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  name: "phone",
  data() {
    return {
      image: null,
      openDialog: false,
      swiperOptions: {
        loop: true,
        autoplay: true,
        clickable: true,
        effect: 'coverflow',
        slidesPerView: 2,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows : true
        },
      },
      baidumapSwitch: false,
      center: { lng: 0, lat: 0 },
      zoom: 16,
      // location: "深圳市",
      // keyword: "请输入搜索关键词",
      labelStyle: {
        padding: "15rem",
        border: "1rem solid #ccc",
        borderRadius: "5rem",
        fontSize: "12rem"
      },
      currentImg: 0,
      imgData: [
        move01,
        move02,
        move03,
        move04,
        move05,
        move06,
        move07,
        move08,
        move09,
        move10,
        move11,
        move12,
        move13,
        move14,
        move15,
        move16,
        move17,
        move18,
        move19,
        move20,
        move21,
        move22,
        move23,
        move24,
        move25,
        move26,
        move27,
        move28
      ],
      twoData: {
        titleData: {
          title: "我们是谁?",
          textList: [
            "我们是一个多元化的文化传播公司",
            "我们是一支征战在策划、设计、演艺市场，具有复合型知识的创意团队",
            "我们是一群凝聚力强、务实高效的年轻人"
          ]
        },
        spanList: [
          {
            src: title1,
            title: "理念",
            textList: [
              "我们坚持以客户为中心，",
              "全方位运作各类商业文化活动，",
              "提供从创意设计到印刷制作、从策划到实施的全程服务。"
            ]
          },
          {
            src: title2,
            title: "创意",
            textList: [
              "我们拥有资深的广告设计专业人员、",
              "优秀的演艺服务体系、丰富的广告策划经验、",
              "独特创新的广告创意制作"
            ]
          },
          {
            src: title3,
            title: "服务",
            textList: [
              "我们珍视每一次合作机会，",
              "期待给客户更有创意，更高效益的媒介宣传效果，",
              "使您的活动和品牌以最经济有效的方式成为众人瞩目的焦点。"
            ]
          }
        ]
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper1.$swiper;
    }
  },
  methods: {
    clickPageAndShowPagse(img, index) {
      this.image = index;
      this.openDialog = true;
    },
    closePage() {
      this.openDialog = false;
    },
    handler() {
      this.center.lng = "121.454205";
      this.center.lat = "31.292364";
    },
    goAnchor(selector) {
      const tag = document.getElementsByClassName(selector)[0].offsetTop;
      document.querySelector("html").scrollTop = tag;
    },
    changeClass(type) {
      if (type === "ALL") {
        this.$refs[type].className = "click-tag";
        this.$refs["BRANDING"].className = "";
        this.$refs["WEB"].className = "";
      }
      if (type === "BRANDING") {
        this.$refs[type].className = "click-tag";
        this.$refs["ALL"].className = "";
        this.$refs["WEB"].className = "";
      }
      if (type === "WEB") {
        this.$refs[type].className = "click-tag";
        this.$refs["BRANDING"].className = "";
        this.$refs["ALL"].className = "";
      }
    }
  }
};
</script>

<style lang="less">
.contentH5 {
  width: 100vw;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  position: relative;

  .fled {
    background: url("../img/H5/top.png") center 100% no-repeat;
    background-size: 100% 100%;
    width: 0.07rem;
    height: 0.07rem;
    position: fixed;
    bottom: 0.02rem;
    right: 0.02rem;
  }
  > div {
    width: 100vw;
    overflow: hidden;
  }
  > .p1 {
    width: 100vw;
    height: auto;
    display: flex;
    justify-content: center;
    background-image: url("../img/H5/p1-h5-bg.png");
    background-size: 100%;

    > .p1-center {
      padding: 0.01rem 0 0 0;
      width: 100vw;
      height: 1.5rem;
      > .p1-title {
        width: 100vw;
        display: flex;
        justify-content: space-between;

        > img {
          width: 0.1rem;
          height: 0.1rem;
        }

        > .title-tab {
          font-family: "Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
          flex: 1;
          display: flex;
          justify-content: space-between;
          padding: 0.05rem;

          > img {
            width: 0.05rem;
            height: 0.05rem;
            &:hover {
              cursor: pointer;
            }
          }
          > div {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 100%;
            margin-right: 0.05rem;
            font-weight: 900;
            font-size: 0.04rem;
            user-select: none;
            color: rgb(255, 255, 255);
            line-height: 1;
            text-align: left;

            > span {
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }

      > .p1-content {
        width: 100vw;
        padding: 0.4rem 0 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          width: 0.35rem;
          height: 0.25rem;
          background-image: url("../img/H5/p1-center.png");
          background-size: 100% 100%;
        }
      }

      > .p1-down {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          width: 0.07rem;
          height: 0.07rem;
          background-image: url("../img/H5/donw-button-h5.png");
          background-size: 100% 100%;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  > .p1-flex {
    position: absolute;
    top: 1.3rem;
    width: 100vw;
    height: 66vw;
    background-image: url("../img/H5/p1dm-h5.png");
    background-size: 100% 100%;
  }

  > .p2 {
    background: #29292c;
    display: flex;
    justify-content: center;
    > div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      padding-bottom: 0.2rem;
      width: 90vw;

      > .p2-title {
        padding-top: 0.5rem;
        width: 100%;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        display: flex;

        > p {
          color: rgb(242, 69, 56);
          font-size: 0.07rem;
          text-align: center;
        }

        > div {
          line-height: 2;
          color: rgb(255, 255, 255);
          font-size: 0.02rem;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }

      > .p2-center {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;

        > div {
          margin-top: 0.15rem;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          align-items: center;
          > img {
            width: 0.15rem;
            height: 0.15rem;
          }
          > p {
            text-align: center;
            font-size: 0.06rem;
            line-height: 1.262;
            color: rgb(242, 69, 56);
          }
          > div {
            text-align: center;
            line-height: 2.556;
            font-size: 0.02rem;
            color: rgb(255, 255, 255);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
          }
        }
      }
    }
  }

  > .p3 {
    width: 100%;
    padding: 0.01rem 0 0.1rem 0;
    border-bottom: 0.001rem solid #666;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: #1d1d1d;

    > .p3-title {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      width: 95vw;
      padding: 0.1rem 0;
      position: relative;

      > :nth-child(2n-1) {
        font-family: "Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
        display: flex;
        flex: 1;
        justify-content: flex-start;
        flex-direction: column;
        align-items: flex-start;
        > span {
          font-size: 0.03rem;
          text-align: left;
          color: rgb(242, 69, 56);
        }
        > p {
          font-size: 0.03rem;
          color: rgb(255, 255, 255);
          text-align: left;
        }

        > div {
          font-size: 0.02rem;
          color: rgb(179, 179, 179);
          text-align: left;
        }
      }

      > :nth-child(2n) {
        font-family: "Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        position: absolute;
        top: 0.11rem;
        right: 0;

        &:hover {
          cursor: pointer;
        }

        > .click-tag {
          position: relative;
          margin-right: 0.018rem;
          font-size: 0.02rem;
          line-height: 1.2;
          text-align: left;
          color: #fff;

          &:after {
            position: absolute;
            bottom: -0.02rem;
            height: 0.002rem;
            left: 0rem;
            width: 100%;
            content: "";
            background-color: #bb9b1d;
          }
        }
        > span {
          position: relative;
          margin-right: 0.018rem;
          font-size: 0.02rem;
          color: #666;
          line-height: 1.2;
          text-align: left;
        }
      }
    }
    > .p3-content {
      margin: 0.05rem 0;
      width: 100vw;
      height: 0.6rem;
      overflow: hidden;

      .swiper-slide{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 0.6rem !important;
      }
      /*.swiper-pagination {*/
      /*  margin-top: 0.1rem;*/
      /*  height: 0.1rem;*/
      /*}*/
      img {
        height: 0.6rem !important;
        margin-right: 0.02rem !important;
        width: 0.42rem !important;
      }
    }
    > .p3-footer {
      color: #666;
      margin-top: 0.1rem;
      display: flex;
      width: 80vw;
      font-size: 0.02rem;
      justify-content: space-between;
      align-items: center;

      > div {
        > .click-page {
          color: #fff;
        }
        > span {
          margin-right: 0.02rem;
          &:hover {
            color: #fff;
            cursor: pointer;
          }
        }
        display: flex;
      }
      > .prev {
        &:hover {
          cursor: pointer;
          color: #fff;
        }
        &:before {
          content: " -- ";
        }
      }
      > .next {
        &:hover {
          color: #fff;
          cursor: pointer;
        }
        &:after {
          content: " -- ";
        }
      }
    }
  }

  > .p4 {
    width: 100vw;
    height: 90vh;
    padding: 0.2rem 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: #1d1d1d;
    > .p4-title {
      font-family: "Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 90vw;
      > :nth-child(2n-1) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        > span {
          font-size: 0.03rem;
          line-height: 1.2;
          text-align: left;
          color: rgb(242, 69, 56);
        }
        > p {
          width: 100%;
          font-size: 0.05rem !important;
          line-height: 1.2;
          text-align: left;

          > span {
            color: rgb(242, 69, 56);
          }
          > .black-text{
            color: rgb(255, 255, 255);
          }

          > img {
            float: right;
            width: .08rem;
            height: .08rem;
          }

        }

        > div {
          font-size: 0.02rem;
          color: rgb(179, 179, 179);
          line-height: 1.6;
          text-align: left;
        }
      }
    }
    > .p4-content {
      height: auto;
      width: 90vw;

      > .map {
        background: #fff;
        height: 0.5rem;
        width: 100%;
      }
    }
    > .p4-footer {
      padding: 0.1rem;
      color: #888;
      font-size: 0.02rem;

      > span {
        color: rgb(242, 69, 56);
      }
      > a {
        color: rgb(255, 255, 255);
      }
    }
  }
}
</style>
